import React from 'react';
import '../App.css';
import { Box } from '@mui/material';

const Loader = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <span className="loader"></span>
            <div className="preload"> iCall Phone Dialer & Contacts</div>
        </div>
    );
};

export default Loader;
